if (Fancybox) {
  Fancybox.Plugins.Thumbs.defaults.autoStart = false;
  Fancybox.Plugins.Toolbar.defaults.display = ['counter', 'close'];

  Fancybox.bind('[data-fancybox]', {
    on: {
      reveal: (fancybox, slide) => {
        const { type } = slide;
        if (type.includes('video') && window.Plyr) {
          new Plyr(slide.$el.querySelector('video'), {
            muted: false,
            controls: ['play-large', 'play', 'progress', 'current-time', 'fullscreen'],
          });
        }
      },
    },
  });
}
